module.exports = __webpack_public_path__ + "offer-analysis.png?030e337278f9cf02115be4c867bceb99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-analysis.png
// module id = 988
// module chunks = 2